export enum VerticalDirection {
  up,
  down,
}
